export default "__VITE_ASSET__59a8f612__"